import { ScrollingModule } from "@angular/cdk/scrolling";
import { ScrollingModule as ExperimentalScrollingModule } from "@angular/cdk-experimental/scrolling";
import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { ComeAndGoAbsenceDialogModule } from "@app/components/come-and-go-absence-dialog/come-and-go-absence-dialog.module";
import { ComeAndGoBoxModule } from "@app/components/come-and-go-box/come-and-go-box.module";
import { ComeAndGoCreateDialogModule } from "@app/components/come-and-go-create-dialog/come-and-go-create-dialog.module";
import { DayPickerPopoverModule } from "@app/components/day-picker-popover/day-picker-popover.module";
import { FrillButtonModule } from "@app/components/frill-button/frill-button.module";
import { ShellMenuToggleModule } from "@app/components/shell-menu-toggle/shell-menu-toggle.module";
import { CoreModule } from "@app/core";
import { MaterialModule } from "@app/material.module";
import { SharedModule } from "@app/shared";
import { TgToolbarModule } from "@app/shared/dialogs/tg-toolbar/tg-toolbar.module";
import { RecordToolbarModule } from "@app/shared/record-toolbar/record-toolbar.module";
import { TimeComegoViewModule } from "@app/shared/time-comego-view/time-comego-view.module";
import { TimeRangePickerModule } from "@app/shared/time-range-picker/time-range-picker.module";
import { TimeTrackerCalendarModule } from "@app/shared/time-tracker-calendar/time-tracker-calendar.module";
import { TimeTrackerTableModule } from "@app/shared/time-tracker-table/time-tracker-table.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { UserMenuModule } from "@app/shared/user-menu/user-menu.module";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { DateFnsModule } from "ngx-date-fns";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { TimerService } from "../timer-calendar-view.service";
import { CalendarDaySidebarComponent } from "./calendar-day-sidebar/calendar-day-sidebar.component";
import { CalendarDaySummaryComponent } from "./calendar-day-summary/calendar-day-summary.component";
import { CalendarTimelineHeaderComponent } from "./calendar-timeline-header/calendar-timeline-header.component";
import { CalendarTimerDaySegmentsComponent } from "./calendar-timer-day-segments/calendar-timer-day-segments.component";
import { CurrentTimeIndicatorComponent } from "./current-time-indicator/current-time-indicator.component";
import { CalendarTimerComponent } from "./timer-calendar-view.component";

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		CoreModule,
		ReactiveFormsModule,
		SharedModule,
		MaterialModule,
		UserMenuModule,
		RecordToolbarModule,
		AngularSvgIconModule,
		InfiniteScrollModule,
		TimeTrackerTableModule,
		TimeTrackerCalendarModule,
		TimeRangePickerModule,
		UserAvatarModule,
		DateFnsModule,
		CustomDirectivesModule,
		NgxSkeletonLoaderModule,
		ScrollingModule,
		ShellMenuToggleModule,
		FrillButtonModule,
		ExperimentalScrollingModule,
		DayPickerPopoverModule,
		ComeAndGoBoxModule,
		TimeComegoViewModule,
		TgToolbarModule,
		ComeAndGoCreateDialogModule,
		ComeAndGoAbsenceDialogModule,
	],
	declarations: [
		CalendarTimerComponent,
		CurrentTimeIndicatorComponent,
		CalendarTimerDaySegmentsComponent,
		CalendarDaySidebarComponent,
		CalendarTimelineHeaderComponent,
		CalendarDaySummaryComponent,
	],
	exports: [CalendarTimerComponent],
	providers: [],
})
export class CalendarTimerModule {
	static forRoot(): ModuleWithProviders<CalendarTimerModule> {
		return {
			ngModule: CalendarTimerModule,
			providers: [TimerService],
		};
	}
}
